import React from 'react'
import { connect } from 'react-redux'
import { addActionToButton, changeGlobalSetting } from "../actions"
import NavBarItem from "../components/NavBarItem"
import constants from "./Constants"
import { tooltips } from "../constants"
import commands from '../json/commands.json'
import Immutable from 'immutable'
import { clearActions, toggleModal, isDownloading } from '../actions'
import { Modals } from "../constants"

// SYSEX CONSTRUCTION //
// 0: 0xF0 Start Bit
// 1: 0x1E DataLooper Identifier
// 2: Action (config start/stop/command
// 3: Button Number
// 4: Execute On
// 5-9 : Data Bit

class Download extends React.Component {
    constructor(props, dispatch) {
        super(props)

        this.state = { midiConnected: false, listenerAdded: false }

    }
    componentDidUpdate() {
        if (this.props.connection.get('input') && !this.state.midiConnected) {
            console.log("setting up midi input listener in downloads", this.props.connection)
            if(!this.state.listenerAdded){
                console.log("midi listener added in download component")
                this.props.connection.get('input').addEventListener("midimessage", this.onMIDIMessage);
                this.setState({
                    listenerAdded: true
                });
            }
            this.setState({
                midiConnected: true
            });
        } else if (!this.props.connection.get('input') && this.state.midiConnected) {
            this.setState({
                midiConnected: false
            });
        }
        if(this.props.connection.get('downloading') && this.state.midiConnected){
            console.log("requesting sysex dump from DL Pedal")
            console.log("Output port state:", this.props.connection.get('output').state)
            console.log("Output port connection:", this.props.connection.get('output').connection)
            try {
                // Add delay to ensure config mode is fully ready
                setTimeout(() => {
                    this.props.connection.get('output').send([0xF0, 0x1E, 15, 0xF7]);
                    console.log("Program dump requested")
                }, 1500); // Wait 1.5 seconds after config mode started
            } catch(err) {
                console.error("Failed to send SysEx request:", err)
            }
            this.props.setIsDownloading(false)
        } 
    }
    onMIDIMessage = (event) => {
        console.log("MIDI message received in Download:", event.data)
        var command_type = event.data[2]

        if (event.data[0] == 0xF0 && event.data[1] == 0x1E)
            if(command_type == 15) {
                console.log("Received global config (command 15)")
                this.receiveGlobalConfig(event.data)
            }
            else if(command_type == 16) {
                console.log("Received preset data (command 16)")
                this.receiveDLPreset(event.data)
            }
            else if(command_type == 17){
                console.log("All presets downloaded (command 17)")
            }
            else {
                console.log("Unknown DataLooper command:", command_type)
            }
        else {
            console.log("Non-DataLooper SysEx message:", event.data)
        }

    }
    findCommand = (actionType, data) => {
        var ret;
        Object.values(commands).forEach(function (cmdType) {
            for (const [key, cmd] of Object.entries(cmdType)) {
                var cmdActionType = parseInt(cmd['data']['data-1'])
                //Return MIDI command type

                if (cmdActionType <= 5 && cmdActionType == actionType) {
                    ret = [key, cmd];
                }
                //Return DL or Sysex command type
                else if (cmdActionType == actionType && parseInt(cmd['data']['data-2']) == data[2])
                    ret = [key, cmd];
            }
        });
        return ret;
    }
    addCommand = (executeOn, actionType, data) => {

        //to find specific command, we need to match data-1 for MIDI Commands, and data-1 and data-2 for everything else

        var command = this.findCommand(actionType, data)
        if (command !== undefined) {
            command[1]['executeOn'] = executeOn
            for (const [key, option] of Object.entries(command[1]['options'])) {
                var dataSlot = option['data-slot']
                command[1]['options'][key]['value'] = data[dataSlot]

            }
            return command
        } else
            return false;
    }
    receiveGlobalConfig = (sysexData) => {
        var ordered = this.props.settings.toOrderedMap().sort(), n = 3
        console.log("ordered map settings", ordered, this.props)
        ordered.forEach(
            function (settingValue, settingKey) {
                console.log("updating setting", settingKey, "to:", sysexData[n])
                this.props.changeGlobalSetting(settingKey,sysexData[n])
                n++;
            }, this
        )
        console.log("updated settings", this.props.settings)
    }
    receiveDLPreset = (sysexData) => {
        var presetNum = sysexData[3]
       // console.log("commands", commands)
        for (var buttonNum = 0; buttonNum < constants.num_buttons; buttonNum++) {
            for (var actionNum = 0; actionNum < constants.num_actions; actionNum++) {
                var sysexIndex = buttonNum * constants.num_actions * constants.action_sysex_size + actionNum * constants.action_sysex_size + 4,
                    command = this.addCommand(sysexData[sysexIndex], sysexData[sysexIndex + 1], sysexData.subarray(sysexIndex, sysexIndex + 7))
                if (command) {
                    //console.log("adding command, ", command, " to button #", buttonNum, " on preset ", presetNum)
                    this.props.addActionToButton((presetNum + 1).toString(), buttonNum.toString(), command[0], Immutable.fromJS(command[1]))
                }
            }
        }
        console.log("presetNum: ", presetNum+1)
        
    }
    requestDLConfig(){
        if (this.props.actions.size > 0) {
            this.props.confirmDownload()
        }else{
            this.props.setIsDownloading(true)
        }
    }



    render() {
        if(this.props.connection.downloading){
            return <NavBarItem tooltip={tooltips.Download} fill={"#4CAF50"} icon={this.props.icon}
            name={this.props.name} />
        }else{
        return <NavBarItem tooltip={tooltips.Download}
            onClick={
                () => this.requestDLConfig()
            }
            icon={this.props.icon}
            name={this.props.name}
        />;
        }
    }

}



function mapDispatchToProps(dispatch) {

    return {
        confirmDownload : () => dispatch(toggleModal({"screen":"downloadModal", "modal": Modals.Download, "success":{screen:"default", action: [clearActions(), isDownloading(true)]}})),
        addActionToButton: (preset, buttonID, actionName, action) => dispatch(addActionToButton(preset, buttonID, actionName, action)),
        setIsDownloading : (downloading) => dispatch(isDownloading(downloading)),
        changeGlobalSetting : (optionName,optionValue) => dispatch(changeGlobalSetting(optionName, optionValue))
    }
}

function mapStateToProps(state) {
    return {
        actions: state.buttonActions.present,
        connection: state.connection,
        settings: state.settings,
        presetSettings: state.presetSettings,
    }
}

export default connect(
    mapStateToProps, mapDispatchToProps)(Download)